@if ((loadGeoLibrariesService.isGoogleLoaded$ | async) === true) {
    <google-map #map height="100%" width="100%" [options]="options" [zoom]="15" (boundsChanged)="boundsChanged()">
        <h-map-google-marker
            [markers]="markers"
            [isMarkerClustererActive]="isMarkerClustererActive"
            [isInMobile]="isInMobile"
            (hoveredMarkerCoordinates)="hoveredMarkerCoordinates.emit($event)"
            (unhoveredMarkerCoordinates)="unhoveredMarkerCoordinates.emit($event)"
            (clickedMarkerCoordinates)="clickedMarkerCoordinates.emit($event)">
        </h-map-google-marker>
    </google-map>
}
